/** When the page and forms are loaded add dirtyForms
 *
 */
// @ts-ignore
hQueryReady(() => {
    $(function () {

        // @ts-ignore
        $('form').dirtyForms({
            fieldSelector: "input:not([type='button'],[type='image'],[type='submit'],[type='reset'],[type='search'],.df-disable),select,textarea"
        });

        $('form').not('.disable-dynamic-save-button').find('.saveButton').attr('disabled', 'disabled').addClass('disabled');

        $('form').not('.disable-dynamic-save-button').on('dirty.dirtyforms clean.dirtyforms', function (ev) {
            var $form = $(ev.target);
            var $submitResetButtons = $form.find('.saveButton');
            if (ev.type === 'dirty') {
                $submitResetButtons.removeClass('disabled').removeAttr('disabled');
            } else {
                $submitResetButtons.attr('disabled', 'disabled').addClass('disabled');
            }
        });

    })
})

/**
 * The function below has been introduced in order to provide DropDownTrees with a mechanism to mark themselves
 * as dirty. When the associated tag helper is rendered this is "wired up" on the page.
 **/
class HicomDirtyForms {
    static setDirtyStatus($field, currentValue): void {
        let original = $field.data('df-orig');
        let form = $field.parents('form');

        if (original !== currentValue) {
            $field.addClass('dirty');
        }
        else {
            $field.removeClass('dirty');
        }
        if (form.dirtyForms('isDirty')) {
            form.trigger('dirty.dirtyforms');
        } else {
            form.trigger('clean.dirtyforms');
        }
    }
    //The function below has been introduced in order to set dirty status in onkeyup event for HTMLEditor
    static setHtmlEditorDirtyStatus($field, currentValue): void {
        let parser = new DOMParser();
        //parser HTML get content of string with HTML tags
        let original = parser.parseFromString($field.data('dfOrig'), "text/html").querySelector("body").textContent;
        let form = $field.parents('form');
        //Removed spaces from original and current value and compare
        if (original.replace(/\s/g, '') !== currentValue.replace(/\s/g, '')) {
            $field.addClass('dirty');
        }
        else {
            $field.removeClass('dirty');
        }
        if (form.dirtyForms('isDirty')) {
            form.trigger('dirty.dirtyforms');
        } else {
            form.trigger('clean.dirtyforms');
        }
    }
}
